// Meetings.jsx
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { supabase, daysBetween, getMeetingStatus, getInitials } from '../lib/supabase'

const AVATAR_COLORS = ['avatar-blue','avatar-green','avatar-purple','avatar-orange','avatar-pink']
const getAvatarColor = (name) => AVATAR_COLORS[(name?.charCodeAt(0) || 0) % AVATAR_COLORS.length]

export function Meetings({ activeFilter }) {
  const [students, setStudents] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => { fetchStudents() }, [activeFilter])

  const fetchStudents = async () => {
    setLoading(true)
    const { data } = await supabase.from('students').select('*').eq('status', activeFilter).order('next_meeting_date')
    if (data) setStudents(data)
    setLoading(false)
  }

  const enriched = students.map(s => ({
    ...s,
    daysToMeeting: s.next_meeting_date ? daysBetween(s.next_meeting_date) : null,
  })).sort((a, b) => (a.daysToMeeting ?? 999) - (b.daysToMeeting ?? 999))

  const overdue = enriched.filter(s => s.daysToMeeting !== null && s.daysToMeeting < 0)
  const upcoming = enriched.filter(s => s.daysToMeeting !== null && s.daysToMeeting >= 0)
  const noMeeting = enriched.filter(s => s.daysToMeeting === null)

  const Section = ({ title, items, emptyMsg }) => (
    <div>
      <div className="section-header"><span className="section-title">{title} <span style={{color:'var(--muted)',fontWeight:400}}>({items.length})</span></span></div>
      {items.length === 0 ? (
        <div style={{color:'var(--muted)',fontSize:13,padding:'12px 0'}}>{emptyMsg}</div>
      ) : (
        <div style={{display:'flex',flexDirection:'column',gap:8}}>
          {items.map(s => {
            const ms = getMeetingStatus(s.daysToMeeting)
            const badgeClass = ms.color === 'red' ? 'badge-red' : ms.color === 'yellow' ? 'badge-yellow' : 'badge-green'
            return (
              <Link key={s.id} to={`/student/${s.id}`} style={{textDecoration:'none'}}>
                <div className="card" style={{padding:'12px 16px',display:'flex',alignItems:'center',gap:12,cursor:'pointer'}}>
                  <div className={`avatar ${getAvatarColor(s.english_name)}`}>{getInitials(s.english_name)}</div>
                  <div style={{flex:1}}>
                    <div style={{fontWeight:600,fontSize:13}}>{s.english_name}</div>
                    <div style={{fontSize:11,color:'var(--muted)'}}>{s.current_school} · Last meeting: {s.last_meeting_date || 'Never'}</div>
                  </div>
                  <span className={`badge ${badgeClass}`}>{ms.label}</span>
                  {s.meeting_booked && <span className="badge badge-green">Booked ✓</span>}
                  <div style={{fontSize:11,color:'var(--muted)',fontFamily:'DM Mono,monospace'}}>→</div>
                </div>
              </Link>
            )
          })}
        </div>
      )}
    </div>
  )

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Meetings</div>
          <div className="page-subtitle">{activeFilter} students · sorted by urgency</div>
        </div>
      </div>
      <div className="page-content">
        {loading ? <div className="loading">Loading...</div> : (
          <>
            <Section title="Overdue" items={overdue} emptyMsg="No overdue meetings 🎉"/>
            <Section title="Upcoming" items={upcoming} emptyMsg="No upcoming meetings scheduled"/>
            <Section title="No meeting date set" items={noMeeting} emptyMsg="All students have a meeting date"/>
          </>
        )}
      </div>
    </div>
  )
}

export default Meetings
